import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import DashboardIcon from "@material-ui/icons/Dashboard";
import MySpaIcon from "@material-ui/icons/Home";
import NotificationsIcon from "@material-ui/icons/Notifications";
import ProfileIcon from "@material-ui/icons/InfoRounded";
import CustomerIcon from "@material-ui/icons/People";
import SettingsIcon from "@material-ui/icons/Settings";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import DeviceHubIcon from "@material-ui/icons/DeviceHub";
import SmsIcon from '@material-ui/icons/Sms';

import { styles } from "./styles";

class Admin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openCollapse: {
        menu: false,
        employee: false,
        mySpa: false,
        promotion: false,
      },
      selected: this.props.selected,
      // userClick: false,
    };
  }

  componentDidMount() {
    this.props.onRef(this);
    this.setState({ selected: this.props.selected });
  }
  handleSelect = (value = "") => {
    if (value !== this.state.selected) this.setState({ selected: value });
  };
  handleClick = (name) => () => {
    let { openCollapse } = this.state;
    openCollapse[name] = !openCollapse[name];
    this.setState(openCollapse);
  };
  render() {
    const { classes, permission, t, moduleRole, open } = this.props;
    const { selected, openCollapse } = this.state;

    if (moduleRole) {
      return (
        <List disablePadding>
          <Link to="/">
            <ListItem
              button
              selected={selected === "" ? true : false}
              onClick={() => this.handleSelect("")}
            >
              <ListItemIcon className={classes.icon}>
                <DashboardIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography variant="body1" className={classes.item}>
                  {t("sidebar_dashboard")}
                </Typography>
              </ListItemText>
            </ListItem>
          </Link>
          <div>
            <ListItem button onClick={this.handleClick("mySpa")}>
              <ListItemIcon className={classes.icon}>
                <MySpaIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography variant="body1" className={classes.item}>
                  Spa
                </Typography>
              </ListItemText>
              {openCollapse.mySpa ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openCollapse.mySpa}>
              <List component="div" disablePadding>
                {open && (
                  <Link to="/service-admin/list">
                    <ListItem
                      className={classes.nested}
                      button
                      selected={selected === "service_list" ? true : false}
                      onClick={() => this.handleSelect("service_list")}
                    >
                      {/* <ListItemIcon className={classes.icon}>
                                                <SpaDetailIcon />
                                            </ListItemIcon> */}
                      <ListItemText>
                        <Typography variant="body1" className={classes.item}>
                          {t("sidebar_list")}
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </Link>
                )}
                {open && (
                  <Link to="/service-admin/package">
                    <ListItem
                      className={classes.nested}
                      button
                      selected={selected === "service_package" ? true : false}
                      onClick={() => this.handleSelect("service_package")}
                    >
                      {/* <ListItemIcon className={classes.icon}>
                                                <SpaDetailIcon />
                                            </ListItemIcon> */}
                      <ListItemText>
                        <Typography variant="body1" className={classes.item}>
                          {t("Manage Package")}
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </Link>
                )}
                {open && (
                  <Link to="/service-admin/add">
                    <ListItem
                      className={classes.nested}
                      button
                      selected={selected === "service_addDetail" ? true : false}
                      onClick={() => this.handleSelect("service_addDetail")}
                    >
                      {/* <ListItemIcon className={classes.icon}>
                                                <SpaDetailIcon />
                                            </ListItemIcon> */}
                      <ListItemText>
                        <Typography variant="body1" className={classes.item}>
                          {t("service_admin_create")}
                        </Typography>
                      </ListItemText>
                    </ListItem>
                  </Link>
                )}
              </List>
            </Collapse>
          </div>
          <Link to="/user">
            <ListItem
              selected={selected === "user" ? true : false}
              button
              onClick={() => this.handleSelect("user")}
            >
              <ListItemIcon className={classes.icon}>
                <CustomerIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography variant="body1" className={classes.item}>
                  {t("sidebar_user")}
                </Typography>
              </ListItemText>
            </ListItem>
          </Link>
          <Link to="/settingSystem">
            <ListItem
              selected={selected === "setting" ? true : false}
              button
              onClick={() => this.handleSelect("setting")}
            >
              <ListItemIcon className={classes.icon}>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography variant="body1" className={classes.item}>
                  {t("sidebar_setting_system")}
                </Typography>
              </ListItemText>
            </ListItem>
          </Link>
          <Link to="/pluginCategory">
            <ListItem
              selected={selected === "pluginCategory" ? true : false}
              button
              onClick={() => this.handleSelect("pluginCategory")}
            >
              <ListItemIcon className={classes.icon}>
                <ShoppingCartIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography variant="body1" className={classes.item}>
                  {t("plugin_category")}
                </Typography>
              </ListItemText>
            </ListItem>
          </Link>

          <Link to="/sms">
            <ListItem
              selected={selected === "sms" ? true : false}
              button
              onClick={() => this.handleSelect("sms")}
            >
              <ListItemIcon className={classes.icon}>
                <SmsIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography variant="body1" className={classes.item}>
                  {t("sidebar_sms")}
                </Typography>
              </ListItemText>
            </ListItem>
          </Link>
          <Link to="/developerAccount">
            <ListItem
              selected={selected === "developerAccount" ? true : false}
              button
              onClick={() => this.handleSelect("developerAccount")}
            >
              <ListItemIcon className={classes.icon}>
                <DeviceHubIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography variant="body1" className={classes.item}>
                  {t("sidebar_develop_account")}
                </Typography>
              </ListItemText>
            </ListItem>
          </Link>
          <Link to="/notification">
            <ListItem
              selected={selected === "notification" ? true : false}
              button
              onClick={() => this.handleSelect("notification")}
            >
              <ListItemIcon className={classes.icon}>
                <NotificationsIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography variant="body1" className={classes.item}>
                  {t("sidebar_notification")}
                </Typography>
              </ListItemText>
            </ListItem>
          </Link>
          <Link to="/profile">
            <ListItem
              selected={selected === "profile" ? true : false}
              button
              onClick={() => this.handleSelect("profile")}
            >
              <ListItemIcon className={classes.icon}>
                <ProfileIcon />
              </ListItemIcon>
              <ListItemText>
                <Typography variant="body1" className={classes.item}>
                  {t("sidebar_profile")}
                </Typography>
              </ListItemText>
            </ListItem>
          </Link>
        </List>
      );
    } else {
      return "";
    }
  }
}

Admin.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  role: state.user.user.roleId.role,
  permission: state.user.user.roleId,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Admin)));
